import React from 'react'
import { AnimatePresence } from 'framer-motion'
import Toast from './Toast'
import useToastStore from '../../stores/toastStore'

const ToastContainer = () => {
  const { toasts, removeToast } = useToastStore()

  return (
    <div className="fixed bottom-28 right-4 z-50">
      <AnimatePresence>
        {toasts.map(toast => (
          <Toast
            key={toast.id}
            toast={toast}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </AnimatePresence>
    </div>
  )
}

export default ToastContainer 